export default {
    hasError: state => state.error ? true : false
}